function randomNumber (start, end) {
  return Math.round(Math.random() * (start + end))
}

export default class {
  constructor (config) {
    this.config = config
  }

  start () {
    console.log('Started')
    const id = randomNumber(1, 1000)
    const startConfig = {
      responseId: `${id}-abcd-efgh`,
      respondentId: id,
      respondTo: `/responses/${id}-abcd-efgh`
    }
    Object.assign(this.config, startConfig)
    const promise = new Promise(function (resolve, reject) {
      resolve({ data: this.config })
    }.bind(this))
    promise.then(
      function (resp) {
        this.config = resp.data
      }.bind(this)
    )
    return promise
  }

  setState (state) {
    this.state = state
  }

  event (data) {
    return new Promise(function (resolve, reject) {
      console.log('Sending event: ', data)
      const result = {
        success: true
      }
      resolve({ data: result })
    })
  }

  update (data) {
    return new Promise(function (resolve, reject) {
      console.log('Update to ' + this.config.respondTo, data)
      const result = {
        update: true
      }
      resolve({ data: result })
    }.bind(this))
  }

  agreement (key) {
    return new Promise(function (resolve, reject) {
      const result = {
        key: key,
        value: 'Your answer',
        agreement: 0.75
      }
      resolve({ data: result })
    })
  }

  result () {
    console.log('Requesting result from ' + this.config.respondTo)
    let sc = 0
    // eslint-disable-next-line no-unused-vars
    for (const scoreEntry in this.state.scoreBoard) {
      const scoreValue = this.state.scoreBoard[scoreEntry]
      sc += scoreValue
    }
    return new Promise(function (resolve, reject) {
      const result = {
        url: 'http://localhost:8080#result/1234-5678-abcd-efgh',
        status: 'complete',
        comparison: {
          score: sc,
          average_score: 7,
          high_score: 12,
          count: 8
        },
        agreement: {
          questions: {
            question1: { answer: 'Yes', pc: 0.33 },
            question2: { answer: 'Natural', pc: 0.43 },
            question3: { answer: 'Brazilian', pc: 0.55 },
            question4: { answer: 'My wife asked me to', pc: 0.57 },
            question5: { answer: 'Once a week', pc: 0.33 },
            question6: { answer: 'At the office, in the stationary cupboard', pc: 0.18 },
            question7: { answer: 'Vigorous', pc: 0.38 },
            question8: { answer: 'Very red', pc: 0.23 }
          },
          average: 0.54332
        }
      }
      resolve({ data: result })
    })
  }

  scores (options) {
    console.log('Retrieving scores')
    return new Promise(function (resolve, reject) {
      const result = {
        _all: {
          score: 59,
          average_score: 45.33,
          max_score: 99,
          high_score: 59,
          count: 9,
          options: {},
          answers: []
        },
        sector: {
          score: 29,
          average_score: 25.33,
          max_score: 35,
          high_score: 34,
          count: 9,
          options: {},
          answers: []
        }
      }
      resolve({ data: result })
    })
  }

  response (uuid) {
    console.log('Requesting response for ' + uuid)
    return new Promise((resolve, reject) => {
      const result = {
        uuid: '18dcb3a9-93f6-4a5f-b197-276a86c4a180',
        url: 'http://localhost:8080#result/18dcb3a9-93f6-4a5f-b197-276a86c4a180',
        session: {
          tokenId: 'c05fc7b6-ff6f-4b2c-9897-3ab1d9498b08',
          respondTo: '/responses/18dcb3a9-93f6-4a5f-b197-276a86c4a180'
        },
        data: {
          barrier: 'Yes',
          language: 'EN',
          '42b4146f3421f7b805ff': 'Answer One'
        },
        status: 'complete',
        signup: { first_name: 'Marc' },
        scores: { answers: { question1: 1, question2: 2 } }
      }
      resolve({ data: result })
    })
  }

  ranking (key) {
    return new Promise(function (resolve, reject) {
      const result = {
        final_score: 6,
        z_score: 0.24443343,
        average_score: 7,
        high_score: 12,
        standard_deviation: 3.43432,
        percentile: 0.2584726,
        cume_dist: 0.34232,
        count: 8
      }
      resolve({ data: result })
    })
  }

  polling (key) {
    const result = {}
    return new Promise(function (resolve, reject) {
      this.answers.forEach(
        (answer) => {
          result[answer.value] = {
            count: 3,
            percent: Math.random(),
            total: 5,
            key: answer.key
          }
        }
      )
      resolve({ data: result })
    }.bind(this))
  }

  breakdown (key) {
    return new Promise(function (resolve, reject) {
      const result = [
        { score: 1, percentage: 0.2, percentile: 0.1, count: 2 },
        { score: 2, percentage: 0.3, percentile: 0.25, count: 3 },
        { score: 3, percentage: 0.2, percentile: 0.55, count: 2 },
        { score: 4, percentage: 0.3, percentile: 0.75, count: 3 }
      ]
      resolve({ data: result })
    })
  }

  promoteUser (data) {
    console.log('Promote ' + this.config.respondTo + '/promote_user', data)
  }

  finalise () {
    console.log('Finalise ' + this.config.respondTo + '/finalise')
    return new Promise(function (resolve, reject) {
      const result = {
        success: true
      }
      resolve({ data: result })
    })
  }
}
